module.exports = __webpack_public_path__ + "img/C.2f206afa.png";